/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Audit/view.blocks to change it.
import * as fromAggregate from 'Simple/Data/aggregate.js'
import * as fromData from 'Simple/Data'
import * as fromFlow from 'Simple/Flow'
import Content from './Content/index'
import No from './No/index'
import React from 'react'



/** @type {import('Simple/types.js').View} */
export default function Audit({
  children,
  viewPath = "/App/ChooseLocation/Support/Audit"
  
}) {
  let flowValue = fromFlow.useFlowValue(viewPath) || 'No'
let selectedXidValueData = fromData.useDataValue({ viewPath,
context: 'selected',
path: 'xid',
})
let globalCurrentLocationXidValueData = fromData.useDataValue({ viewPath,
context: 'global',
path: 'current_location.xid',
})
let aggregateData = fromAggregate.not(selectedXidValueData, globalCurrentLocationXidValueData)
fromData.useSetFlowToBasedOnDataValue({ viewPath,
value: Boolean(aggregateData),
})
  return (<React.Fragment
>
<fromFlow.When is={flowValue === 'No'}>
<No
  viewPath={`${viewPath}/No`}
/>
</fromFlow.When>
<fromFlow.When is={flowValue === 'Content'}>
<Content
  viewPath={`${viewPath}/Content`}
/>
</fromFlow.When>
{children}
</React.Fragment>)
}